<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="{ or: ['Product_ProductFloating_Add', 'Product_ProductFloating_Edit'] }">
		<template #badges>
			<nk-badge system="sale">
				<nk-badge-item type="system" modelValue="sale"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="retreiveIsEmpty() ? 'edit' : 'new'"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="h-100 d-flex flex-column" ref="floatingInfo">
			<div class="form-container">
				<form>
					<div class="container-fluid">
						<div class="row">
							<div class="col-12">
								<div class="nk-card">
									<div class="row">
										<div class="col-12 col-sm-6 mt-1">
											<nk-col-form-group :label="$t('sale.product-floating.f.isEnabled') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-switch v-model="localData.isEnabled" :tabindex="101"></nk-switch>
											</nk-col-form-group>
										</div>
									</div>
									<div class="row">
										<div class="col-12 col-sm-6">
											<nk-col-form-group :label="$t('sale.product-floating.f.name') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input v-model="localData.name" :tabindex="102" ref="pFloatingName" startup></nk-input>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-6 mt-1">
											<nk-col-form-group :label="$t('sale.product-floating.f.valueType') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="productValueType" @update:modelValue="valueTypeDropDownChanged" :data="valueType" :options="componentOptions.valueType" :tabindex="103"></nk-dropdown>
											</nk-col-form-group>
										</div>
									</div>
									<div class="row">
										<div class="col-12 col-sm-6  mt-1">
											<nk-col-form-group :label="$t('sale.product-floating.f.dataType') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="productDataType" :data="dataType" :options="componentOptions.dataType" :tabindex="104"></nk-dropdown>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-6 mt-1">
											<nk-col-form-group class="custom-label" :label="$t('sale.product-floating.f.uniqueMode') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="productUniqueMode" :data="uniqueMode" :options="componentOptions.uniqueMode" :tabindex="105"></nk-dropdown>
											</nk-col-form-group>
										</div>
									</div>
									<div class="row">
										<div class="col-12 col-sm-6 mt-1">
											<nk-col-form-group :label="$t('sale.product-floating.f.displayOrder') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input :options="componentOptions.number" v-model="localData.displayOrder" :tabindex="106"></nk-input>
											</nk-col-form-group>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
			<div class="p-floatingValues mt-4 container-fluid" style="min-height: 300px;" v-show="localData && localData.valueType && localData.valueType === 'Selective'">
				<div class="nk-card h-100">
					<nk-table :data="localData.productFloatingValues" :options="componentOptions.productFloatingValues" v-model="selectedItem" ref="floatingValuesTable" tabindex="200" class="w-100">
					</nk-table>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import { mapActions } from 'vuex'
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import validators, { Checker, isEmpty, VCustom } from '~/statics/validators'
	import Endpoints from '@nikan/endpoints'
	import emptyId from '~/statics/empty-id'

	export default {
		modal: {
			size: 'md',
			stateUID: 'products-floating-modify',
			helpTag: 'ProductFloatingModify'
		},

		props: {
			data: { type: Object },
			options: { type: Object },
		},
		data() {
			return {
				componentOptions: {
					number: {
						required: true,
						mode: 'integer',
					},
					valueType: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return this.$t(item.group + '.' + item.key.toLowerCase())
						},
						searchableFields: ['key'],
						searchPrefix: 'ValueTypes'
					},
					dataType: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return this.$t(item.group + '.' + item.key.toLowerCase())
						},
						searchableFields: ['key'],
						searchPrefix: 'ProductFloatingDataTypes'
					},
					uniqueMode: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return this.$t(item.group + '.' + item.key.toLowerCase())
						},
						searchableFields: ['key'],
						searchPrefix: 'UniqueModes'
					},
					productFloatingValues: {
						alwaysEmit: true,
						searchable: false,
						colIndicatorBarEnabled: true,
						activeRowDisabled: false,
						editable: true,
						allowNewRow: true,
						row_ID: 'id',
						buttons: {
							addBtn: {
								options: {
									visible: true
								}
							},
							deleteBtn: {
								options: {
									visible: true
								}
							},
						},
						prepareNewRow: () => {
							return {
								productFloatingId: this.localData.id,
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								editable: false,
								width: '70px|>70px',
								entering: false,
								pinned: true,
								pinnable: false,
								aggregates: [
									{
										type: 'count'
									},
								],
							},
							{
								name: 'code',
								title: this.$t('sale.product-floating-value.f.code'),
								type: 'string',
								edit: {
									component: Input,
									options: {
										mode: 'string',
									},
								},
								editable: true,
								entering: true,
								validators: validators('required'),
								width: 100,
							},
							{
								name: 'title',
								title: this.$t('sale.product-floating-value.f.title'),
								type: 'string',
								edit: {
									component: Input,
									options: {
										mode: 'string',
									},
								},
								editable: true,
								entering: true,
								width: 250,
							},
							{
								name: 'displayOrder1',
								title: this.$t('sale.product-floating-value.f.displayOrder'),
								type: 'number',
								edit: {
									component: Input,
									options: {
										mode: 'integer',
									},
								},
								editable: true,
								entering: true,
								validators: validators('required'),
								width: 100,
							},
						],
					},
				},
				selectedItem: null,
				localData: {
					id: emptyId,
					name: '',
					displayOrder: null,
					isEnabled: true,
					dataType: null,
					valueType: null,
					uniqueMode: null,
					productFloatingValues: null,
				},
				dataType: [],
				valueType: [],
				uniqueMode: [],
				validators: {
					name: validators('required'),
					isEnabled: validators('required'),
					valueType: validators('required'),
					dataType: validators('required'),
					uniqueMode: validators('required'),
					displayOrder: validators('required'),
				},
				saveProductFloating: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					icon: 'save',
					isPrimary: true,
					handle: () => {
						this.validateThenSave()
					},
					policyClaims: { or: ['Product_ProductFloating_Add', 'Product_ProductFloating_Edit'] },
				},
			}
		},
		computed: {
			productValueType: {
				get() {
					return _.head(
						this.valueType.filter(
							(x) => _.toLower(x.key) === _.toLower(this.localData.valueType)
						)
					)
				},
				set(obj) {
					this.localData.valueType = obj?.key
				},
			},
			productUniqueMode: {
				get() {
					return _.head(
						this.uniqueMode.filter(
							(x) => _.toLower(x.key) === _.toLower(this.localData.uniqueMode)
						)
					)
				},
				set(obj) {
					this.localData.uniqueMode = obj?.key
				},
			},
			productDataType: {
				get() {
					return _.head(
						this.dataType.filter(
							(x) => _.toLower(x.key) === _.toLower(this.localData.dataType)
						)
					)
				},
				set(obj) {
					this.localData.dataType = obj?.key
				},
			},
		},
		mounted() {
			this.localData = _.extend({}, this.localData, this.data)

			this.localData.productFloatingValues?.map(x => x.displayOrder1 = x.displayOrder)

			this.prepareWindow(this.$t(`sale.product-floating-modify.title`), [
				this.saveProductFloating
			])
			this.getProperties()
		},
		methods: {
			...mapActions({
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			valueTypeDropDownChanged() {
				if (this.localData.valueType === 'Manual') {
					this.$refs.floatingValuesTable
						.commitChanges().then(productFloatingValues => {
							this.localData.productFloatingValues = productFloatingValues
						})
				}
			},
			commitTableChanges() {
				return new Promise((resolve, reject) => {
					if (this.localData.valueType === 'Selective') {
						this.$refs.floatingValuesTable
							.commitChanges().then(result => { resolve(result) })
							.catch((errorRows) => {
								if (Array.isArray(errorRows)) {
									var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
									dialog({
										title: this.$t('sale.product-floating.m.save-error-title'),
										body: this.$t('sale.product-floating.m.save.error.rows', {
											rowNumbers,
										}),
										type: 'error',
										isPrimary: true,
									})
								} else {
									dialog({
										title: this.$t('sale.product-floating.m.save-error-title'),
										body: this.$t('sale.product-floating.m.save-error', {
											name: this.localData.name,
											errors: errorRows.message,
										}),
										type: 'error',
										isPrimary: true,
									})
								}
							})
					} else {
						resolve(this.localData.productFloatingValues)
					}

				})
			},
			validateThenSave() {
				if (this.validateInputs()) {
					this.commitTableChanges()
						.then((productFloatingValues) => {
							this.save(productFloatingValues)
						})
						.catch(() => { })
				}
			},
			save(productFloatingValues) {
				var url
				var wait = this.$wait(this.grandParent)
				let cloned = _.cloneDeep(this.localData)

				if (this.localData.valueType === 'Selective') {
					cloned.productFloatingValues = productFloatingValues
					cloned.productFloatingValues?.map(x => x.displayOrder = x.displayOrder1)

				}
				else
					cloned.productFloatingValues = []

				if (isEmpty(this.localData.id)) {
					url = Endpoints.getUrl('sale.product.floating.create')
				} else {
					url = Endpoints.getUrl('sale.product.floating.update')
				}

				var data = {
					ProductFloating: cloned,
				}
				post(url, data)
					.then((result) => {
						wait.end()
						this.broadcastRefresh('ProductFloatings')
						this.$toast(this.$t('msg.create-success'), { type: 'success' })
						this.clearForm()
						this.resolve(this.localData)
						this.selectedItem = null
					})
					.catch((err) => {
						wait.end()
					})
			},
			validateInputs() {
				let checker = new Checker((f) =>
					this.$t(`sale.product-floating.f.${f}`)
				)
				let errors = checker.test(this.localData, this.validators)
				if (this.localData.valueType == 'Selective' && (!this.$refs.floatingValuesTable || this.$refs.floatingValuesTable.getTableData().data.length == 0)) {
					errors.push({
						key: '',
						error: this.$t(
							'sale.product-floating.m.floatingValues-required'
						),
					})
				}
				this.validationToast(errors)
				return errors.length === 0
			},
			getProperties() {
				this.dataType = this.getPropertiesByGroup('ProductFloatingDataTypes')
				this.valueType = this.getPropertiesByGroup('ValueTypes')
				this.uniqueMode = this.getPropertiesByGroup('UniqueModes')
			},
			clearForm() {
				this.localData = {
					name: '',
					displayOrder: null,
					isEnabled: false,
					dataType: null,
					valueType: null,
					uniqueMode: null,
					productFloatingValues: null,
				}
			},
			retreiveIsEmpty() {
				if (isEmpty(this.localData.id)) {
					return false
				} else {
					return true
				}
			},
		},
	}
</script>
<style>
	.p-floatingValues {
		overflow: hidden;
		flex: 1;
	}

	.custom-label label {
		white-space: pre;
		margin-right: -5px;
	}

	.product-table table {
		min-height: 250px;
	}
</style>
